import { APP_ICONS } from '../../static/appIcons.js';
import { NAVIGATION_PATHS } from '../../static/navigationPaths.js';
import { FORGE_AI_ICON } from '../PBBStrategist/pbbStrategistHelpers.js';

export const useNavigationLinks = () => {
  const navItems = [
    {
      title: 'Home',
      name: 'Home',
      iconName: 'home',
      to: NAVIGATION_PATHS.HOME,
      menu: 'main',
    },
    {
      title: 'Manage budget',
      name: 'Manage budget',
      iconName: 'tools',
      subItems: [
        {
          title: APP_ICONS.BUDGET_SUMMARY,
          name: APP_ICONS.BUDGET_SUMMARY,
          to: NAVIGATION_PATHS.BUDGET_SUMMARY,
          menu: 'main',
        },
        {
          title: APP_ICONS.BUDGET_LINE_ITEM_EDITOR,
          name: APP_ICONS.BUDGET_LINE_ITEM_EDITOR,
          to: NAVIGATION_PATHS.BUDGET_LINE_ITEM_EDITOR,
          menu: 'main',
        },
      ],
    },
    {
      title: APP_ICONS.PROGRAM_INVENTORY,
      name: APP_ICONS.PROGRAM_INVENTORY,
      iconName: 'inventory',
      to: NAVIGATION_PATHS.PROGRAM_INVENTORY,
      menu: 'main',
    },
    {
      title: APP_ICONS.COST_ALLOCATION,
      name: APP_ICONS.COST_ALLOCATION,
      iconName: 'money',
      to: NAVIGATION_PATHS.COST_ALLOCATION,
      menu: 'main',
    },
    {
      title: 'Program scoring',
      name: APP_ICONS.DEPARTMENT_SCORING,
      iconName: 'score',
      subItems: [
        {
          title: APP_ICONS.DEPARTMENT_SCORING,
          name: APP_ICONS.DEPARTMENT_SCORING,
          to: NAVIGATION_PATHS.DEPARTMENT_SCORING,
          menu: 'main',
        },
        {
          title: APP_ICONS.DEPARTMENT_REVIEW,
          name: APP_ICONS.DEPARTMENT_REVIEW,
          to: NAVIGATION_PATHS.DEPARTMENT_REVIEW, //temporary link to department scoring review page
          menu: 'main',
        },
        {
          title: APP_ICONS.PEER_REVIEW,
          name: APP_ICONS.PEER_REVIEW,
          to: NAVIGATION_PATHS.PEER_REVIEW,
          menu: 'main',
        },
        {
          title: APP_ICONS.FINAL_REVIEW,
          name: APP_ICONS.FINAL_REVIEW,
          to: NAVIGATION_PATHS.FINAL_REVIEW, //temporary link to final review page
          menu: 'main',
        },
      ],
    },
    {
      title: APP_ICONS.DATA_VISUALIZATION,
      name: APP_ICONS.DATA_VISUALIZATION,
      iconName: 'table_chart',
      to: NAVIGATION_PATHS.DATA_VISUALIZATIONS,
      menu: 'main',
    },
    {
      title: APP_ICONS.PROGRAM_INSIGHTS,
      name: APP_ICONS.PROGRAM_INSIGHTS,
      iconName: 'insights',
      to: NAVIGATION_PATHS.PROGRAM_INSIGHTS, //temporary link to program insights page
      menu: 'main',
    },
    {
      title: APP_ICONS.BUDGET_REQUESTS,
      name: APP_ICONS.BUDGET_REQUESTS,
      iconName: 'request_page',
      to: NAVIGATION_PATHS.BUDGET_REQUESTS,
      menu: 'main',
    },
    {
      title: APP_ICONS.REPORTS,
      name: APP_ICONS.REPORTS,
      iconName: 'file_download',
      to: NAVIGATION_PATHS.REPORTS,
      menu: 'main',
    },
    {
      title: APP_ICONS.PBB_STRATEGIST,
      name: APP_ICONS.PBB_STRATEGIST,
      iconName: FORGE_AI_ICON,
      to: NAVIGATION_PATHS.PBB_STRATEGIST,
      menu: 'main',
    },
    {
      title: APP_ICONS.COST_BENCHMARK,
      name: APP_ICONS.COST_BENCHMARK,
      iconName: FORGE_AI_ICON,
      to: NAVIGATION_PATHS.COST_BENCHMARK,
      menu: 'main',
    },
  ];

  const settingsItems = [
    {
      title: 'Tenant setup',
      name: 'Tenant setup',
      iconName: 'settings',
      subItems: [
        {
          title: APP_ICONS.ORGANIZATIONAL_HIERARCHY,
          name: APP_ICONS.ORGANIZATIONAL_HIERARCHY,
          to: NAVIGATION_PATHS.ORGANIZATIONAL_HIERARCHY,
          menu: 'settings',
        },
        {
          title: APP_ICONS.NAME_CONVENTIONS,
          name: APP_ICONS.NAME_CONVENTIONS,
          to: NAVIGATION_PATHS.NAME_CONVENTION,
          menu: 'settings',
        },
        {
          title: APP_ICONS.MANAGE_USERS,
          name: APP_ICONS.MANAGE_USERS,
          to: NAVIGATION_PATHS.MANAGE_USERS,
          menu: 'settings',
        },
        {
          title: APP_ICONS.MANAGE_USER_ACCESS,
          name: APP_ICONS.MANAGE_USER_ACCESS,
          to: NAVIGATION_PATHS.MANAGE_USER_ACCESS,
          menu: 'settings',
        },
        {
          title: APP_ICONS.USER_ACTIVITY,
          name: APP_ICONS.USER_ACTIVITY,
          to: NAVIGATION_PATHS.USER_ACTIVITY,
          menu: 'settings',
        },
        {
          title: APP_ICONS.CONFIGURE_BUDGET,
          name: APP_ICONS.CONFIGURE_BUDGET,
          to: NAVIGATION_PATHS.CONFIGURE_BUDGET,
          menu: 'main',
        },
        {
          title: APP_ICONS.CONFIGURE_SCORING,
          name: APP_ICONS.CONFIGURE_SCORING,
          to: NAVIGATION_PATHS.CONFIGURE_SCORING,
          menu: 'settings',
        },
        {
          title: APP_ICONS.CONFIGURE_INSIGHTS,
          name: APP_ICONS.CONFIGURE_INSIGHTS,
          to: NAVIGATION_PATHS.CONFIGURE_INSIGHTS, //temporary link to insights purpose page
          menu: 'settings',
        },
        {
          title: APP_ICONS.CONFIGURE_REQUESTS,
          name: APP_ICONS.CONFIGURE_REQUESTS,
          to: NAVIGATION_PATHS.CONFIGURE_REQUESTS,
          menu: 'settings',
        },
      ],
    },
    {
      title: 'PBB setup',
      name: 'PBB setup',
      iconName: 'wrench',
      subItems: [
        {
          title: APP_ICONS.ORGANIZATION_EDITOR,
          name: APP_ICONS.ORGANIZATION_EDITOR,
          to: NAVIGATION_PATHS.ORGANIZATION_EDITOR,
          menu: 'settings',
        },
        {
          title: APP_ICONS.MANAGE_ADMIN_USERS,
          name: APP_ICONS.MANAGE_ADMIN_USERS,
          to: NAVIGATION_PATHS.MANAGE_ADMIN_USERS,
          menu: 'settings',
        },
        {
          title: APP_ICONS.MANAGE_ORGANIZATION_ACCESS,
          name: APP_ICONS.MANAGE_ORGANIZATION_ACCESS,
          to: NAVIGATION_PATHS.MANAGE_ORGANIZATION_ACCESS,
          menu: 'settings',
        },
        {
          title: APP_ICONS.MANAGE_DATA,
          name: APP_ICONS.MANAGE_DATA,
          to: NAVIGATION_PATHS.MANAGE_DATA,
        },
        {
          title: APP_ICONS.AI_ANALYTICS,
          name: APP_ICONS.AI_ANALYTICS,
          to: NAVIGATION_PATHS.AI_ANALYTICS,
        }
      ],
    },
  ];

  return { navItems, settingsItems };
};
